module.exports = __webpack_public_path__ + "static/media/unlock-tool.1420e90f.svg";